var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 952,
    viewBox: "0 0 1512 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1512 594.812C1512 594.812 1512 590.81 1511.78 607.319C1502.91 619.36 1478.66 642.904 1418.85 688.862C1269.1 803.922 1077.24 836.94 876.449 836.94C717.687 836.94 411.02 753.706 211.349 836.94C70.7191 895.562 0.500461 952 0.500461 952V121.064H1512L1512 594.812Z",
    fill: "#ADD7F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1511.5 0C1511.5 0 1147.54 120.389 909.504 112.559C700.147 105.673 590.983 24.5402 381.631 17.5091C232.319 12.4945 0 92.0483 0 92.0483V391.205C0 391.205 203.872 336.065 337.558 318.167C639.155 277.788 810.869 386.122 1114.84 372.195C1270.86 365.047 1511.5 318.764 1511.5 318.764V0Z",
    fill: "#ADD7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveHomepage);
export default __webpack_public_path__ + "static/media/wave_homepage.1321518c56fbe302574eae87033e6155.svg";
export { ForwardRef as ReactComponent };